import React from "react";
import { Container, Grid, Paper, Typography, Button, Box } from "@mui/material";
import { useLocation } from "react-router-dom";

// Sample pricing data
const pricingData = [
  {
    title: "Free Plan",
    price: "$0",
    features: ["1 Project", "5 GB Storage", "Email Support"],
    highlight: false,
  },
  {
    title: "Basic Plan",
    price: "$19/month",
    features: ["5 Projects", "50 GB Storage", "Priority Email Support"],
    highlight: true,
  },
  {
    title: "Premium Plan",
    price: "$49/month",
    features: ["Unlimited Projects", "200 GB Storage", "Phone & Email Support"],
    highlight: false,
  },
];

const Pricing = () => {
  const location = useLocation();
  const { param1 } = location.state || {};
  console.log(param1);

  return (
    <Container maxWidth="lg" sx={{ paddingTop: "40px" }}>
      <Typography variant="h3" align="center" gutterBottom>
        Our Pricing Plans
      </Typography>
      <Typography variant="body1" align="center" gutterBottom>
        Choose a plan that works best for you. No credit card required.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {pricingData.map((plan, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Paper
              elevation={3}
              sx={{
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                border: plan.highlight ? "2px solid #1976d2" : "none",
              }}
            >
              <Typography variant="h5" gutterBottom>
                {plan.title}
              </Typography>
              <Typography variant="h4" color="primary" gutterBottom>
                {plan.price}
              </Typography>
              <Box sx={{ flexGrow: 1 }}>
                <ul style={{ paddingLeft: 0 }}>
                  {plan.features.map((feature, i) => (
                    <li key={i}>
                      <Typography variant="body2">{feature}</Typography>
                    </li>
                  ))}
                </ul>
              </Box>
              <Button variant="contained" color="primary" fullWidth>
                Get Started
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Pricing;
